<script lang="ts" setup>
import { SliderRange, SliderRoot, SliderThumb, SliderTrack } from 'radix-vue'

const values = defineModel<number[]>({
    required: true
})

defineProps({
    min: {
        type: Number,
        required: true
    },
    max: {
        type: Number,
        required: true
    },
    step: {
        type: Number,
        default: 0.1
    },
    disabled: {
        type: Boolean,
        default: false
    },
    showLabels: {
        type: Boolean,
        default: true
    }
})
</script>

<template>
    <div class="flex w-full items-center">
        <span
            v-if="values.length === 2 && showLabels"
            class="w-[25px] text-start"
        >
            {{ $n(values[0]!) }}
        </span>
        <SliderRoot
            v-model="values"
            class="relative flex items-center select-none touch-none w-full h-5"
            :min
            :max
            :step
            :disabled
        >
            <SliderTrack class="bg-slate-200 relative grow rounded-full h-2">
                <SliderRange
                    class="absolute bg-primary-500 rounded-full h-full"
                />
            </SliderTrack>
            <SliderThumb
                v-for="(_thumb, index) in values"
                :key="index"
                class="bg-white border-2 border-primary-500 rounded-full cursor-grab focus:outline-none w-5 h-5 disabled:cursor-not-allowed focus:ring focus:ring-primary-500 focus:ring-opacity-30"
                aria-label="Slider"
            />
        </SliderRoot>
        <span
            v-if="values.length === 2 && showLabels"
            class="w-[25px] text-end"
        >
            {{ $n(values[1]!) }}
        </span>
    </div>
</template>

<style>
.slider-horizontal {
  height: 8px;
}
.slider-horizontal .slider-icons {
  top: -0.4rem;
}
</style>
